import type { SubscriptionType } from '../../../types/Shared';
import BigScreenNav from './BigScreenNav';
import SmallScreenNav from './SmallScreenNav';

export interface NavItemInterface {
  name: string;
  path: string;
  icon: (props: React.ComponentProps<'svg'>) => React.ReactNode;
  subMenu?: SubNavItemInterface[];
  subscription?: SubscriptionType;
  permissions?: string[];
  roles?: readonly string[];
}
export interface SubNavItemInterface {
  name: string;
  path: string;
  permissions?: string[];
  roles?: readonly string[];
}

export default function SidebarNav({ sidebarOpen, closeSideBar }: { sidebarOpen: boolean; closeSideBar: () => void }) {
  return (
    <>
      <SmallScreenNav sidebarOpen={sidebarOpen} closeSideBar={closeSideBar} />
      <BigScreenNav />
    </>
  );
}
